import { useToaster } from '@/composables/game/toasters'

const { notify } = useToaster()

const useClipboard = () => {
  const copyToClipboard = (text: string, successText?: string) => {
    if (window.navigator.clipboard) {
      window.navigator.clipboard.writeText(text)
      if (successText) {
        notify({
          title: successText,
          type: 'success',
        })
      }
    } else {
      console.warn('no clipboard available', text)
    }
  }

  return {
    copyToClipboard,
  }
}

export {
  useClipboard,
}